import React from 'react';
import { ArrowRightIcon, LockKeyholeIcon, ShieldCheckIcon } from 'lucide-react';
interface ActionButtonProps {
  href?: string;
  children: React.ReactNode;
  showTrust?: boolean;
  className?: string;
}
export function ActionButton({
  href = '#pricing',
  children,
  showTrust = false,
  className = ''
}: ActionButtonProps) {
  return <div className={className} data-id="element-12">
      <a href={href} className="group inline-flex w-full items-center justify-center gap-2 rounded-full bg-brand-green px-6 py-4 text-center font-display text-base font-bold text-white shadow-[0_8px_28px_rgba(22,163,74,0.26)] transition hover:bg-brand-light hover:text-brand-ink sm:text-lg" data-id="element-13">
        {children}
        <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-14" />
      </a>
      {showTrust && <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-slate-400" data-id="element-15">
          <span className="inline-flex items-center gap-1.5" data-id="element-16">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-light" data-id="element-17" />
            Garantía 30 días
          </span>
          <span className="inline-flex items-center gap-1.5" data-id="element-18">
            <LockKeyholeIcon className="h-3.5 w-3.5" data-id="element-19" />
            Pago seguro
          </span>
          <span data-id="element-20">Mercado Pago</span>
        </div>}
    </div>;
}